<template>
  <div>

    <CRow >
      <CCol md="12">
        <CCard>
          <CCardHeader>

            <CRow>
              <CCol col="8" style="text-align: start ;padding:0px 20px 0 20px ">
                <strong>{{ $t('purchaseReport') }}</strong>
              </CCol>
              <CCol col="4" style="text-align: end ;padding:0px 20px 0 20px ">

                <CButton
                    class="mr-1"
                    size="sm"
                    @click="print_with_header_title_height(body_id,header_id,footer_id,$t('purchaseReport'),100,100)"
                    color="secondary"
                >{{ $t("buttons.print") }}
                </CButton>
              </CCol>

            </CRow>
          </CCardHeader>
          <br>

          <CRow>

            <CCol col="3">
              <CSelect
                  :label="$t('tables.type')"
                  horizontal
                  :value.sync="selected_type_parent"
                  :options="[{label:$t('Suppliers'),value:0},{label:$t('items'),value:1}]"
              />
            </CCol>
            <CCol col="3">
              <date-picker
                  :label="$t('components.startDate')"
                  v-model="start_date"></date-picker>
            </CCol>
            <CCol col="3">
              <date-picker
                  :label="$t('components.endDate')"
                  v-model="end_date"></date-picker>
            </CCol>
            <CCol col="1" v-if="selected_type_parent==0">
              <CButton @click="get_lists_customer" color="dark"
                       size="sm">
                <CIcon size="sm" name="cil-zoom"/>
              </CButton>
            </CCol>
          </CRow>
          <CRow v-if="selected_type_parent==0">


<!--            <CCol>-->
<!--              <CSelect-->
<!--                  :label="$t('components.province')"-->

<!--                  :options="province_items"-->
<!--                  :value.sync="selected_province"/>-->

<!--            </CCol>-->
<!--            <CCol>-->
<!--              <CSelect-->
<!--                  :label="$t('components.city')"-->

<!--                  :options="city_items"-->
<!--                  :value.sync="selected_city"/>-->

<!--            </CCol>-->
<!--            <CCol>-->
<!--              <CSelect-->
<!--                  :label="$t('town')"-->

<!--                  :options="district_items"-->
<!--                  :value.sync="selected_district"/>-->
<!--            </CCol>-->
<!--            <CCol>-->
<!--              <CSelect-->
<!--                  :label="$t('components.area')"-->

<!--                  :options="area_items"-->
<!--                  :value.sync="selected_area"/>-->

<!--            </CCol>-->

<!--            <CCol>-->
<!--              <CSelect-->
<!--                  :label="$t('route')"-->
<!--                  :options="route_items"-->
<!--                  :value.sync="selected_route"/>-->
<!--            </CCol>-->
<!--            <CCol>-->
<!--              <CSelect-->
<!--                  :label="$t('country')"-->
<!--                  :value.sync="selected_country"-->
<!--                  :options="country_items"-->
<!--              />-->
<!--            </CCol>-->

          </CRow>
          <CRow v-if="selected_type_parent==1">
            <CCol col="12">
              <CRow>

<!--                <CCol col="2">-->
<!--                  <CSelect-->
<!--                      :value.sync="selected_branch"-->
<!--                      :options="branch_items"-->
<!--                  />-->
<!--                </CCol>-->
                <CCol col="2">
                  <CSelect
                      :value.sync="selected_category"
                      :options="category_items"
                  />
                </CCol>
                <CCol col="2">
                  <select v-model="selected_place" class="form-control"

                  >
                    <option value="0">
                      {{ $t('components.selectWarehouse') }}
                    </option>
                    <option v-for="option in places_items" v-bind:value="option.id">
                      {{ option.placeName }}
                    </option>
                  </select>
                </CCol>
                <CCol col="1">
                  <CButton @click="get_lists_products" color="dark"
                           size="sm">
                    <CIcon size="sm" name="cil-zoom"/>
                  </CButton>
                </CCol>
              </CRow>
            </CCol>

          </CRow>

          <CRow :id="body_id">
            <CCol col="12">
              <CCardBody  v-show="selected_type_parent==0">

                <CDataTableFixed
                    :items="items_customer"
                    :fields="fields_customer"
                    :column-filter="get_filter_table"
                    sorter
                    :items-per-page="20"
                    hover
                    border
                    :pagination="get_pagination"
                    striped
                >
                  <template #row_id="{item,index}">

                    <td style="text-align: center">
                      <p>{{ index + 1 }}</p>
                    </td>
                  </template>

                  <template #amount="{item}">
                    <td>
                      <p  style="float: right">{{ get_currency(item.amount) }}</p>
                    </td>
                  </template>

                  <template #customerCode="{item}">
                    <td>
                      <p  style="text-align: center">{{ item.customerCode }}</p>
                    </td>
                  </template>


                  <template #under-table>
                    {{$t('totalPrice')}} : {{get_currency(calculate_items(items_customer,'amount'))}}
                  </template>
                </CDataTableFixed>
              </CCardBody>

              <CCardBody v-show="selected_type_parent==1">
                <CDataTableFixed
                    :items="items_products"
                    :fields="fields_products"
                    :column-filter="get_filter_table"
                    :items-per-page="20"
                    hover
                    sorter
                    border
                    :pagination="get_pagination"
                    striped
                >
                  <template #row_id="{item,index}">

                    <td style="text-align: center">
                      <p>{{ index + 1 }}</p>
                    </td>
                  </template>


                  <template #qty="{item}">
                    <td>
                      <p  style="float: right">{{ item.qty }}</p>
                    </td>
                  </template>
                  <template #productCode="{item}">
                    <td>
                      <p  style="text-align: center">{{ item.productCode }}</p>
                    </td>
                  </template>
                  <template #amount="{item}">
                    <td>
                      <p  style="float: right">{{ get_currency(item.amount) }}</p>
                    </td>
                  </template>
                </CDataTableFixed>
              </CCardBody>

            </CCol>
          </CRow>

        </CCard>
      </CCol>

    </CRow>
    <div v-show="false" :id="header_id" style="margin-right: 50px;margin-left: 50px;">
      <CCol>
        <CRow style="justify-content:center">
          <strong style="font-size: large">{{get_bussiness_name()}}</strong>
        </CRow>
        <CRow style="justify-content:center">
          <strong>{{$t('saleReport')}}</strong>
        </CRow>
        <CRow>
          <CCol >
            <label>{{$t('FromDate')}} {{get_date(start_date)}}</label>
          </CCol>
          <CCol style="text-align:center" >
            <label >{{$t('UpToDate')}} {{get_date(end_date)}}</label>
          </CCol>
          <CCol style="text-align:end" >
            <label >{{$t('PreparedDate')}} {{get_date(get_today())}}</label>
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <label v-if="selected_city!=0">{{city_items.filter(x=>x.cityId == selected_city)[0].cityName}} ,</label>
            <label v-if="selected_district!=0">{{district_items.filter(x=>x.id == selected_district)[0].title}} ,</label>
            <label v-if="selected_route!=0">{{route_items.filter(x=>x.id == selected_route)[0].title}}</label>

          </CCol>
        </CRow>
      </CCol>

    </div>
    <div v-show="false" :id="footer_id" class="border-dark">
      <CCardHeader>
        <CRow style="border: 1px solid #000">


          <CCol sm="4" md="4" style="text-align: start">
            <h5>{{ $t('docCreator') }} : {{ get_user_name() }}</h5>
          </CCol>
          <CCol sm="4" md="4" style="text-align: center">
            <h2 id="pageFooter" class="pageFooter"></h2>
          </CCol>
          <CCol sm="4" md="4" style="text-align: end">
            <h2>
            </h2>
          </CCol>
        </CRow>

      </CCardHeader>

    </div>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Vue from "vue";
import Treeselect from '@riophae/vue-treeselect'

import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
import moment from 'moment-jalaali'
import BTabs from "../../tabs/BTabs";

import SaleReportOneCustomer from "../sell/SaleReportOneCustomer";
import SaleReportAllCustomer from "../sell/SaleReportAllCustomer";
import SaleInvoiceReport from "../sell/SaleInvoiceReport";
import SaleProductsReport from "../sell/SaleProductsReport";
import CustomerList from "../sell/CustomerList";
var simulateAsync=null
    const simulateAsyncOperation = fn => {
        if(simulateAsync!=null){
            clearTimeout(simulateAsync)
        }
        simulateAsync =  setTimeout(fn, 1000)
    }
export default {
  name: 'Login',
  components: {
    Treeselect,
    SaleReportAllCustomer,
    SaleReportOneCustomer,
    SaleInvoiceReport,
    SaleProductsReport,
    CustomerList
  },
  data() {
    return {
      body_id: 'print_report_body_purchase_pro_cus',
    header_id: 'print_report_header_purchase_pro_cus',
    footer_id: 'print_report_footer_purchase_pro_cus',
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      VUE_APP_Currency: localStorage.getItem('currency'),
      items_customer: [],
      items_customer_all: [],
      start_date: '',

      types_all: [],
      types_parent: [],
      selected_type_parent: 0,
      selected_type_child: 0,
      selected_status:0,
      end_date: '',
      fields_customer: [//amount amountNegetive accBalance accBalanceNegetive
        {key: 'row_id', label: this.$t('tables.row'), sorter: false, _style: 'width:5%'},
        {key: 'customerCode', label: this.$t('tables.code'), _style: 'width:10%'},
        {key: 'customerName', label: this.$t('name'), _style: 'width:10%'},
        {key: 'surName', label: this.$t('lastName'), _style: 'width:10%'},
        {key: 'amount', label: this.$t('tables.amount'), _style: 'width:10%'},
        {key: 'paymentType', label: this.$t('payTypeCash'), _style: 'width:10%'},
        // {key: 'paymentStatus', label: this.$t('paymentStatus'), _style: 'width:10%'},
      ],

      fields_products: [
        {key: 'row_id', label: this.$t('tables.row'), sorter: false, _style: 'width:5%'},
        {key: 'productCode', label: this.$t('components.productCode'), _style: 'width:10%'},
        {key: 'productName', label: this.$t('components.productName'), _style: 'width:10%'},
        {key: 'qty', label: this.$t('Quantity'), _style: 'width:10%'},
        {key: 'amount', label: this.$t('tables.amount'), _style: 'width:10%'},

      ],
      selected_place: 0,
      places_items: [],
      branch_items: [],
      selected_branch: 0,
      category_items: [],
      selected_category: 0,

selected_person_name:'',

      normalizer_accounting(node) {
        return {
          id: node.id,
          label: node.accountCode + " " + node.accountName,
        }
      },
      normalizer_accounting_tafzili(node) {
        return {
          id: node.recId,
          label: node.title,
        }
      },
      load_persons({action, searchQuery, callback}) {

        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            let options;
            const formData = new FormData();

            formData.append('SearchTxt', searchQuery);
            var url = "GetAllPersons";

            formData.append('IsVendor', true);
            formData.append('IsWorker', false);
            formData.append('IsCustomer', false);
            formData.append('IsActive', 0);

            axios.post(url, formData, {show_pros: true}).then(function (response) {
              options = response.data.data;

              callback(null, options);

            })
                .catch(function (error) {

                  console.log(error);
                });

          })
        }
      },
      normalizer_persons(node) {
        return {
          id: node.userId,
          label: node.fullName + " " + node.personCode,
        }
      },
      templates_items: [],
      accounting_list: [],
      items_products: [],
      moein_list: [],
      tafsili_list: [],
      selected_person: null,
      selected_moein: null,
      selected_tafsili: null,
      collapseDuration: 0,
      person_name: '',
      status_form: 0,

      route_items: [],
      selected_route: 0,

      area_items: [],
      selected_area: 0,

      province_items: [],
      selected_province: 0,

      city_items: [],
      selected_city: 0,

      district_items: [],
      selected_district: 0,

      country_items: [],
      selected_country: 0,
      table_clicks:0,
      table_clicks_timer:null,
      checkbox_all_items:[],
      check_all_exit:false,
      person_async_list:[],
      sync_person:true,
    }
  }, mounted() {

    this.$root.root_validate_errors = [];
    this.get_lists_groups();
    this.get_country()
    this.get_routes()
    this.get_all_customers()
    this.get_branch();
    this.get_categories()
    this.get_places();

    // this.get_lists();
    this.start_date = this.get_day_before_today(1);
    this.end_date = this.get_today();
    this.get_lists_customer()
    this.get_lists_products()
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    'check_all_exit':function(){
     if(this.check_all_exit){
       this.items_customer_all.forEach(function (val){
         this.checkbox_all_items.push(val.personId);
       });

     } else{
       this.checkbox_all_items=[];
     }
    },
    'selected_type_parent': function () {

    },
    'selected_province': function () {

      this.get_cities();
    },
    'selected_city': function () {
      this.get_districts();
    },
    'selected_district': function () {
      this.get_areas();
    },
    'selected_country': function () {
      this.get_provinces();
    },
  },
  methods: {
    get_branch() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetBranchList', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.branch_items = [];
          self.branch_items = self.sort_array(
              self.branch_items, content_data.data,
              'branchId', 'branchTitle');

          self.selected_branch = self.branch_items[0].value

        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_categories() {
      var self = this;


      const formData = new FormData();

      axios.post('GetAllCats', formData, {
        params: {
          // isparent : self.$route.params.cat_id
        },
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
          //         fields;
          self.category_items = [];
          var obj = {label: self.$t('dialogs.insertCategory'), value: 0}
          self.category_items.push(obj);
          self.category_items = self.sort_array(
              self.category_items, content_data.data,
              'catTitleId', 'catTitle');


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },

    get_places() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetPlaces', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
          //         fields;
          self.places_items = content_data.data;


        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },

    select_user(node, instance) {
    this.selected_person_name = node.fullName+" "+node.personCode;

    },
    get_all_customers() {
      var self = this;


      const formData = new FormData();
      var url = "GetAllPersons";

      formData.append('IsVendor', false);
      formData.append('IsWorker', false);
      formData.append('IsCustomer', true);
      formData.append('IsActive', 0);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.items_all_customer = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    get_country() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetCountries', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {

          self.country_items = [];

          self.country_items = self.sort_array(
              self.country_items, content_data.data,
              'id', 'title');

          if (self.$i18n.locale == 'fa') {
            self.selected_country = self.country_items.filter(x => x.label == 'ایران')[0].value
          }
          if (self.$i18n.locale == 'en') {
            self.selected_country = self.country_items.filter(x => x.label == 'England')[0].value
          }

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_provinces() {
      var self = this;

      const formData = new FormData();


      formData.append('id', this.selected_country);


      axios.post('GetStateList', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.province_items = [];
          self.province_items.push({label:self.$t('dialogs.insertProvince'),value:0});

          self.province_items = self.sort_array(
              self.province_items, content_data.data,
              'id', 'provinceName');


          self.selected_province = self.province_items[0].value;

        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_cities() {
      var self = this;

      const formData = new FormData();


      formData.append('id', this.selected_province);

      axios.post('GetCityListByStateId', formData, {show_pros: true}).then(function (response) {

        var content_data = response.data;
        self.city_items = []
        self.selected_city =0;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
          //         fields;
          self.city_items = []
          self.city_items = self.sort_array(
              self.city_items, content_data.data,
              'cityId', 'cityName');

          self.selected_city = self.city_items[0].value;

        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_districts() {
      var self = this;

      const formData = new FormData();


      formData.append('id', this.selected_city);

      axios.post('GetRegionByCityId', formData, {show_pros: true}).then(function (response) {

        var content_data = response.data;
        self.district_items = []
        self.selected_district =0;
        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
          //         fields;
          self.district_items = self.sort_array(
              self.district_items, content_data.data,
              'id', 'title');

          self.selected_district = self.district_items[0].value;

        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_areas() {
      var self = this;

      const formData = new FormData();


      formData.append('id', this.selected_district);

      axios.post('GetAreaTitlesByCityId', formData, {show_pros: true}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
          //         fields;
          self.area_items = []
          self.area_items = self.sort_array(
              self.area_items, content_data.data,
              'id', 'areaName');

          // content_data.data.forEach((val) => {
          //   var obj = {label: val.areaName, value: val.id}
          //
          //   self.area_items.push(obj);
          // });
          self.selected_area = self.area_items[0].value;
        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_routes() {
      var self = this;

      const formData = new FormData();

      axios.post('GetRoutesNew', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.route_items = [{label: self.$t('all'), value: 0}]
          self.route_items = self.sort_array(self.route_items, content_data.data, 'id', 'title')
          self.selected_route = self.route_items[0].value;


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);
        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    get_style(item) {
      var color = '#56ff42';
      if(item.personAccountId==0){
        // return 'backgroundColor: \'#56ff42\'';
        return {

          backgroundColor: color

        }
      }

    },
    get_sum_debtor(list,field) {
      var sum = 0;
      list.forEach((val) => {
        val[field] = val[field].toString().replace(/,/g, '');
        sum += parseInt(val[field]);
      })
      return sum;
    },
    get_sum_credetor(list,field) {
      var sum = 0;
      list.forEach((val) => {
        val[field] = val[field].toString().replace(/,/g, '');

        sum += parseInt(val[field]);
      })
      return sum;
    },
    edit_item(item) {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = item.unitName;
      this.color = item.color;
      this.description = item.description;
      this.previewImage = item.image;
      this.status_form = item.id;
    },
    emptyList() {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = '';
      this.color = '';
      this.description = '';
      this.previewImage = '';
      this.status_form = 0;

      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    }, edit_sale_method(item) {
      this.selected_method = item.saleMethodId;
      this.selected_person = item.userId;
      this.saleMethodModal = true;

    },
    select_moein(node) {
      var self = this;

      const formData = new FormData();
      var url = "GetAccountTafsiliList";
      formData.append("id", node.id);

      // self.tafzili_list = [];

      axios.post(url, formData, {}).then(function (response) {

            var content_data = response.data;

            if (content_data.statusCode == 0) {

              // item.tafzili_list = response.data.data;
              self.tafsili_list = response.data.data
            } else {
              self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

            }

          }
      ).catch(function (error) {
        console.log(error);
      });

    },
    get_lists_groups() {

      var self = this;
      self.items_parent = [];
      self.data_with_children = []

      const formData = new FormData();
      var url = "Get_AllAccountingGroups";

      axios.post(url, formData, {}).then(function (response) {

            var content_data = response.data;

            if (content_data.statusCode == 0) {

              self.accounting_list = response.data.data
              response.data.data.forEach((val) => {
                if (val.parentId == 0) {

                  self.get_childrens_one_sub(val.id, self.accounting_list).forEach((val2) => {

                    self.get_childrens_one_sub(val2.id, self.accounting_list).forEach((val3) => {

                      self.moein_list.push(val3)

                    });

                  });

                }

              });
            } else {
              self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

            }

          }
      )
          .catch(function (error) {
            console.log(error);
          });

    },
    get_childrens_one_sub(parent_id, list) {
      var array = [];
      var self = this;
      list.forEach((val2) => {

        if (parent_id == val2.parentId) {
          // var obj = {label: val2.accountCode + " " + val2.accountName, value: val2.id, code: val2.accountCode}
          array.push(val2);


        }
      });
      return array;
    },
    load_data() {

    },
    get_lists_customer() {
      var self = this;


      const formData = new FormData();

      var url = "GetPublicSalesByTypeId";

      formData.append('FromDate', this.start_date);
      formData.append('ToDate', this.end_date);
      formData.append('CountryId', this.selected_country);
      formData.append('CityId', this.selected_city);
      formData.append('ProvinceId', this.selected_province);
      formData.append('RegionId', this.selected_district);
      formData.append('AreaId', this.selected_area);
      formData.append('RouteId', this.selected_route);
      formData.append('TypeId', 1);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;
        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.items_customer = content_data.data;
          // self.items_customer.forEach(function (val) {
          //   val.amount = "S"+val.amount.toString()
          // })
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_lists_products() {
      var self = this;


      const formData = new FormData();

      var url = "GetGoodsSalesRpt";


      formData.append('FromDate', this.start_date);
      formData.append('ToDate', this.end_date);
      formData.append('GrpId', this.selected_category);
      formData.append('PlaceId', this.selected_place);
      formData.append('BranchId', this.selected_branch);
      formData.append('TypeId', 1);


      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;
        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.items_products = content_data.data;
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    goEditPerson(item) {

      this.$router.push({path: '/dashboard/users/edit-user/' + item.userId});

    },
    goToDocuments(item) {

      this.$router.push({path: '/dashboard/documents/show/' + item.masterId});

    },



  }
}

</script>
